// extracted by mini-css-extract-plugin
export var card = "_j5-5";
export var cardSelected = "_j5-4";
export var image = "_j5-3";
export var modal = "_j5-0";
export var modalContent = "_j5-1";
export var table = "_j5-2";